export const getHeightAndWidthFromDataUrl = dataUrl => new Promise(resolve => {
  const img = new Image();
  img.onload = () => {
    resolve({
      height: img.height,
      width: img.width,
    });
  };

  img.src = dataUrl;
});

export const getExtFromUrl = (url) => {
  const urlObj = new URL(url);
  const { pathname } = urlObj || {};
  if (!pathname) return;
  const ext = pathname.substring(pathname.lastIndexOf('.') + 1);
  return ext.includes('/') ? '' : ext;
};

export const dataURLtoFile = (dataUrl, filename) => {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[arr.length - 1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  /* eslint-disable-next-line no-plusplus */
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type:mime });
};

export const getHexEncodedBytesHeader = (file, length = 8) => {
  if (!file) return Promise.reject(new Error('No file'));
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = (e) => {
      const arr = (new Uint8Array(e.target.result)).subarray(0, length);
      let header = '';
      for (let i = 0; i < arr.length; i += 1) {
        if (arr[i] < 16) {
          // 0 gets added here to be compatible with backend.
          header += `0${arr[i].toString(16)}`;
        } else {
          header += arr[i].toString(16);
        }
      }
      resolve(header);
    };
    reader.onabort = () => reject(new Error('abort'));
    reader.onerror = () => reject(new Error('error'));
    reader.readAsArrayBuffer(file);
  });
};

export const getBase64 = (file) => {
  if (!file) {
    return Promise.reject(new Error('No file'));
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(String(reader.result));
    reader.onerror = () => reject(new Error('error'));
    reader.onabort = () => reject(new Error('abort'));
    reader.readAsDataURL(file);
  });
};

export const getFileData = (file, length) => {
  const header = getHexEncodedBytesHeader(file, length);
  const b64 = getBase64(file);
  return Promise.all([header, b64]);
};

export const downloadImage = (fileUrl, filename) => {
  fetch(fileUrl, {
    method: 'GET',
    cache: 'no-cache',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
  .then((response) => response.blob())
  .then((blob) => {
    // Create blob link to download
    const url = window.URL.createObjectURL(
      new Blob([blob]),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      filename,
    );

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);
  });
};
